import * as React from 'react';
import { Toaster as SonnerToaster, toast } from 'sonner';
import type { ToasterProps } from 'sonner';

export { toast };

export function Toaster({ position = 'top-right', ...props }: ToasterProps): React.ReactElement {
  return <SonnerToaster position={position} {...props} />;
}
